import React from "react";
import ICategory from '../components/menu/categories/ICategory';
import { CategoriesDialogForm, ICategoriesDialogForm } from "../components/modal/CategoriesDialogForm";
import FormSwitchWithText from '../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText';
import FormTextBox from '../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox';
import FormSelect from '../yoello-lib/modules/dynamicForms/FormComponents/FormSelect';
import IDynamicFormRow from '../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow';
import { DeleteItems } from "../yoello-lib/modules/dynamicForms/CustomFormComponents/DeleteItems";
import FormTitle from '../yoello-lib/modules/dynamicForms/FormComponents/FormTitle';

export function createCategoryFormRows(props: ICategoriesDialogForm, categories: ICategory[], isEposNow: boolean, isNewItem: boolean,t:(key:string)=>string, isSquare?: boolean , onFailedInteraction?:Function): IDynamicFormRow[] {
    //@TODO - not a good solution, backend should handle this
    const filteredCategories = isSquare ?
        categories?.filter((cat: ICategory) => cat.category_name === 'MENU') :
        categories?.filter((cat: ICategory) => cat.category_name !== 'MENU' && cat.category_name !== 'MAIN')

    let formRows: IDynamicFormRow[] = [
        {
            label: "menu.subcategories.generalInfo",
            Component: (props: any) => <FormTitle title={props.label} />,
            keyName: "details-subheading",
        },
        {
            label: "forms.categories.name",
            keyName: "subcategory_name",
            Component: FormTextBox,
            registerOptions:
            {
                required: true
            },
            gridColumnOptions: { formCol: 4 },
            disabled: isEposNow
        },
        {
            Component: FormTextBox,
            label: "forms.categories.description",
            keyName: "subcategory_desc",
            gridColumnOptions: { formCol: 8 },
        },
        {
            label: "forms.categories.parent",
            keyName: "category_id",
            Component: FormSelect,
            formProps: {
                selectOptions: filteredCategories ? filteredCategories.map((cat: ICategory) => { return { name: t(`menu.subcategories.${cat.category_name}`), value: cat.id }; }) : [],
            },
            registerOptions: {
                required: true
            },
            gridColumnOptions: { formCol: 12 },
            disabled: isEposNow
        },
        {
            label: "forms.categories.enabled",
            keyName: "enabled",
            Component: FormSwitchWithText,
            gridColumnOptions: { formCol: 12 },
            formProps: {
                hasStatus: true,
            },
            inputProperties: {
                defaultChecked: true,
            },
        },
    ];

    if (!isNewItem && !isEposNow) {
        formRows = [...formRows, {
            label: "delete.label",
            Component: DeleteItems,
            formProps: {
                rawProps: props, item: props.formData, ParentComponent: CategoriesDialogForm,
                callAPI: props.callSubcategory, keyLabel: 'subcategories', closeAllModals: () => props.history.goBack(),
                onFailedInteraction:onFailedInteraction
            },
            keyName: "delete",
        }]
    }

    return formRows;
}
